import API from './api';

export const getSafetyConfig = () => API.get('/messages/safety-config');

export const updateSafetyConfig = (data) => API.put('/messages/safety-config', data);

export const listSafetyAcknowledgements = (params = {}) =>
  API.get('/reports/safety-acknowledgements', { params });
